module.exports = __webpack_public_path__ + "static/img/smallapp_preview2.be3f793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preview/smallapp_preview2.png
// module id = BYtZ
// module chunks = 1